// `.chip` del mock 03: píldora de inventario con las tres pieles (success / warning / danger).
// Se comparte entre la tarjeta del grid y el panel de detalle para que digan lo mismo, siempre.
import { cn } from '@/lib/cn';
import { chipDe, type StockTone } from '../catalogFilters';
import type { CatalogItem } from '../types';

const PIEL: Record<StockTone, string> = {
    success: 'border-success-soft-border bg-success-soft text-success',
    warning: 'border-warning-soft-border bg-warning-soft text-warning',
    danger: 'border-destructive/40 bg-destructive/10 text-destructive',
};

const BASE =
    'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium leading-[1.35]';

export function StockChip({
    item,
    className,
}: {
    item: Pick<CatalogItem, 'itemType' | 'stock'>;
    className?: string;
}) {
    const { tone, label } = chipDe(item);
    return <span className={cn(BASE, PIEL[tone], className)}>{label}</span>;
}

/** Chip libre con la misma piel — para estados que no salen de un número de stock. */
export function ToneChip({
    tone,
    children,
    className,
}: {
    tone: StockTone;
    children: React.ReactNode;
    className?: string;
}) {
    return <span className={cn(BASE, PIEL[tone], className)}>{children}</span>;
}
